import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePatternPublishedQuery } from "../services/patternApi";
import { formatDate } from "../utils/dateFormat";
import styles from "./PublishDate.module.css";
interface PropType {
  patternId: string;
}

export const PublishDate = (props: PropType) => {
  const { data, isLoading } = usePatternPublishedQuery(`${props.patternId}`, {
    skip: parseInt(props.patternId) === -1,
  });

  const [first, setFirst] = useState<string | null>(null);
  const [latest, setLatest] = useState<string | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const firstDate = data?.published[0]?.created;
    const latestDate = data?.published[data.published.length - 1]?.created;

    if (firstDate) {
      setFirst(firstDate);
    }
    if (latestDate) {
      setLatest(latestDate);
    }
  }, [isLoading]);

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>
        {first === null
          ? t("publish_pattern.not_published")
          : latest === null
          ? t("publish_pattern.published", { date: formatDate(first) })
          : t("publish_pattern.published_and_updated", {
              first: formatDate(first),
              latest: formatDate(latest),
            })}
      </p>
    </div>
  );
};
